<div class="content" [ngClass]="{'border-content': !configHeader.hidden}">
    <span class="title" *ngIf="!configHeader.hidden">Objeto</span>
    <div class="header" *ngIf="!configHeader.hidden">
        <p class="name">{{name ? name : 'Objeto'}}</p>
        <div class="btn-actions">
            <button type="button" (click)="open()" *ngIf="(object.data | json) !== '{}'" mat-icon-button>
                <mat-icon>{{isOpen ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}}</mat-icon>
            </button>
            <button type="button" (click)="onDelete()" mat-icon-button>
                <mat-icon>delete</mat-icon>
            </button>
            <button type="button" mat-icon-button (click)="openDialog()" [disabled]="configHeader.disableSettingButton">
                <mat-icon>settings</mat-icon>
            </button>
        </div>
    </div>
    <div class="content-data" *ngIf="isOpen">
        <div *ngFor="let item of object.data | keyvalue" class="content-data-item">
            <json-template-array *ngIf="(item.value | type) === 'array'" [data]="object.data" [name]="item.key" [_index]="item.key" (deleteEvent)="delete($event)" [breadcrumb]="nextBreadcrumb"></json-template-array>
            <json-template-object *ngIf="(item.value | type) === 'object'" [data]="object.data" [name]="item.key" [index]="item.key" (deleteEvent)="delete($event)" [breadcrumb]="nextBreadcrumb"></json-template-object>
            <json-template-property *ngIf="(item.value | type) === 'string'" [data]="object.data" [name]="item.key" [index]="item.key" (deleteEvent)="delete($event)" [breadcrumb]="nextBreadcrumb"></json-template-property>
        </div>
    </div>
</div>
